<template>
  <div class="tabs-container">
    <img v-if="isShowOne" src="../../../../assets/images/home/highlights.png" alt="">
    <van-tabs
      v-else
      class="tabs-wrapper"
      v-model="active"
      :before-change="beforeChange"
    >
      <Highlights/>
      <BoostList
        :cityInfo="cityInfo"
        :activityAllInfo="activityAllInfo"
      />
      <RosterList
        :activityAllInfo="activityAllInfo"
        v-if="isShowFinal"
        :isLogin="isLogin"
      />
    </van-tabs>
  </div>
</template>
<script>
import Highlights from './highlights'
import BoostList from './boostList'
import RosterList from './rosterList'

export default {
  props: {
    activityAllInfo: {
      type: Object,
      required: true
    },
    personalArtical: {
      type: Object,
      default() {
        return {}
      }
    },
    cityInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    isLogin: {
      type: Boolean,
      required: true
    }
  },
  components: {
    Highlights,
    BoostList,
    RosterList
  },
  data() {
    return {
      active: 0,
      isActive: false,
      isFirstTabTrigger: true
    }
  },
  watch: {
    activityAllInfo: {
      handler(value) {
        let active = 0
        const { activity_status } = value.activityInfo
        if (this.isLogin) {
          if (activity_status === 1) {
            active = 1
          } else if ([2, 3, 4].includes(activity_status)) {
            active = 2
          }
        }

        this.active = active
      },
      immediate: true,
      deep: true
    },
    isLogin(val) {
      if (val) {
        this.isLogin = val
      }
    }
  },
  computed: {
    isShowOne() {
      return this.activityAllInfo.activityInfo.activity_status === 0
    },
    isShowFinal() {
      return [2, 3, 4].includes(this.activityAllInfo.activityInfo.activity_status)
    }
  },
  methods: {
    beforeChange(index) {
      if (index === 0) {
        this.$xesLogger.clickMsg({
          params: { clickid: '10.0.8', elemname: '点击[活动亮点]Tab' }
        })
      } else if (index === 1) {
        this.$xesLogger.clickMsg({
          params: { clickid: '10.0.9', elemname: '点击[人气榜单]Tab' }
        })
      } else if (index === 2) {
        const { activityInfo } = this.activityAllInfo || {}
        const { activity_status } = activityInfo || {}
        if (activity_status === 3 || activity_status === 2) {
          this.$xesLogger.clickMsg({
            params: { clickid: '203', elemname: '点击[复选名单]Tab' }
          })
        } else {
          this.$xesLogger.clickMsg({
            params: { clickid: '204', elemname: '点击[决胜名单]Tab' }
          })
        }
      }
      return true
    }
  }
}
</script>

<style lang="less" scoped>
  /deep/ .van-tab__pane {
    text-align: center;
  }

  /deep/ .one-img {
    display: inline-block;
    margin: 16px 0 0;
  }

  .tabs-container {
    padding-bottom: 28px;

    .tabs-wrapper {
      margin: 8px 13px 0;
      overflow: hidden;
      background: #fff;
      border: 1px solid #ffdc51;
      border-radius: 8px;
      box-shadow: 0 0 24px 0 rgba(191, 191, 191, 0.31), 0 -1px 0 0 #f7f1e2;

      /deep/ .van-tabs__nav {
        background: #f7f1e2;
        box-shadow: 0 0 24px 0 rgba(191, 191, 191, 0.31), 0 -1px 0 0 #f7f1e2;
      }

      /deep/ .van-tab--active {
        font-size: 15px;
        font-weight: 600;
        font-family: PingFangSC-Semibold, PingFang SC;
        line-height: 21px;
        color: #333;
      }
    }
  }
</style>
